// extracted by mini-css-extract-plugin
export default {"root":"SimpleAvatarPlayer_root__7QlAg","img":"SimpleAvatarPlayer_img__jPFGA","portrait":"SimpleAvatarPlayer_portrait__IVrKh"};